import React, { ReactElement, VFC } from 'react';

import classNames from 'classnames';
import { useTheme } from 'mintel-react-ui';

import { BlockBackgroundsType, Theme } from '/types';

import styles from './PanelColumn.scss';

/**
 * A panel to use with StatColumn and AssetColumn.
 */
const PanelColumn: VFC<{
  background?: BlockBackgroundsType;
  children: ReactElement;
  panelOnImage?: boolean;
  hide?: boolean;
}> = ({
  background = 'bg-white',
  children,
  panelOnImage = false,
  hide = false,
}) => {
  const theme: Theme = useTheme();

  return (
    <div className={classNames(styles.outer, { [styles.hide]: hide })}>
      <div
        className={classNames(styles[`${background}-${theme}`], {
          [styles['panel-on-image']]: panelOnImage && background === 'bg-image',
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default PanelColumn;
